// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"e4655f00","175":"bd28dd9b","529":"01222631"}[chunkId] + ".chunk.css";
};